<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :otherParams="{'isDealerId':navSwitch,startDate,endDate}"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow()"
    >

      <template v-slot:[toolbarConfig.templatelSlots]>

        <div class="top_btns_box"
             style="display: flex"
             v-auth="`VIEW`"
        >
          <div class="status_box">
            <span class="status_item" :class="!navSwitch?'active':''" @click="changeNav(0)">区域线索池</span>
            <span class="status_item" :class="navSwitch?'active':''" @click="changeNav(1)">经销商线索池</span>
          </div>

          <div class="btns_box">
            <!--        <vxe-button @click="addRow"><a-icon type="diff"/> 新增</vxe-button>-->
            <!--            厂家-->
            <vxe-button v-if="['厂家主管副总','厂家部长','厂家员工','系统管理员'].includes(role)" style="border: none;width: 100px"
            >
              <a-upload
                  name="file"
                  :multiple="false"
                  :accept="'.xlsx'"
                  :action="api.clue.FactorImportUPLOAD"
                  :headers="{token:token}"
                  @change="importHandleChange"
              >
                <vxe-button>厂家导入</vxe-button>
              </a-upload>
            </vxe-button>


            <vxe-button @click="download(1)" v-if="['厂家主管副总','厂家部长','厂家员工','系统管理员'].includes(role)">下载厂家导入模板
            </vxe-button>
            <vxe-button @click="showTransferPopFunc" v-auth="`TRANSFER`">
              转移
            </vxe-button>
            <!--            厂家end-->

            <!--            经销商-->
            <vxe-button v-if="['经销商总经理','经销商客户经理','经销商市场经理','经销商信息管理员','经销商客服专员','经销商销售顾问'].includes(role)"
                        style="border: none;width: 105px"
            >
              <a-upload
                  name="file"
                  :multiple="false"
                  :accept="'.xlsx'"
                  :action="api.clue.DealerImportUPLOAD"
                  :headers="{token:token}"
                  @change="importHandleChange"
              >
                <vxe-button>经销商导入</vxe-button>
              </a-upload>
            </vxe-button>
            <vxe-button @click="download(2)"
                        v-if="['经销商总经理','经销商客户经理','经销商市场经理','经销商信息管理员','经销商客服专员','经销商销售顾问'].includes(role)">下载经销商导入模板
            </vxe-button>

            <vxe-button v-auth="`DISTRIBUTE`" v-if="navSwitch"
                        @click="showAssignPopFunc">
              分配
            </vxe-button>
            <a-popconfirm title="确定退回线索公海？" ok-text="确定" cancel-text="取消" @confirm="backToSea(null)"
                          v-auth="`BACK`"
                          v-if="navSwitch">
              <vxe-button>
                退回公海
              </vxe-button>
            </a-popconfirm>

            <!--            经销商end-->

            <vxe-button @click="receiveFunc" v-auth="`RECEIVE`">领取</vxe-button>

            <vxe-button @click="delRow">删除</vxe-button>


          </div>
        </div>
      </template>

      <template v-slot:operate="{row}">
        <vxe-button v-show="row.isReceive === 0" style="margin-right: 10px" size="mini" status="primary"
                    @click="receiveFunc(row)"
                    v-auth="`RECEIVE`"
        >
          领取
        </vxe-button>

        <vxe-button style="margin-right: 10px" size="mini" status="primary"
                    @click="showAssignPopFunc(row)"
                    v-auth="`DISTRIBUTE`"
        >分配
        </vxe-button>
        <!--        <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="toVoidFunc(row)">作废</vxe-button>-->
        <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="showTransferPopFunc(row)"
                    v-auth="`TRANSFER`"
                    v-show="!navSwitch">转移
        </vxe-button>

        <a-popconfirm title="确定退回线索公海？" ok-text="确定" cancel-text="取消" @confirm="backToSea(row)"
                      v-auth="`BACK`"
                      v-show="navSwitch">
          <vxe-button style="margin-right: 10px" size="mini" status="primary">
            退回公海
          </vxe-button>
        </a-popconfirm>
        <!--        <vxe-button size="mini" @click="delRow(row)">删除</vxe-button>-->
      </template>

    </x-grid>

    <!-- 详情页 -->
    <formModal
        title="线索池详情"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="detailPage"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="detailPage"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>

    <!-- 导入线索 弹窗 -->
    <!--    <formModal-->
    <!--        title="导入线索"-->
    <!--        centered-->
    <!--        :closable="false"-->
    <!--        :footer="null"-->
    <!--        :maskClosable="false"-->
    <!--        :visible="showImportPop"-->
    <!--        :width="600"-->
    <!--    >-->
    <!--      <vxe-button @click="download">下载模板</vxe-button>-->
    <!--      <br/>-->
    <!--      <br/>-->
    <!--      <br/>-->
    <!--      <a-upload-->
    <!--          name="file"-->
    <!--          :multiple="false"-->
    <!--          :accept="'.xlsx'"-->
    <!--          :action="api.clue.DealerImportUPLOAD"-->
    <!--          :headers="{token:token}"-->
    <!--          @change="importHandleChange"-->
    <!--      >-->
    <!--        <vxe-button>线索池导入</vxe-button>-->
    <!--      </a-upload>-->

    <!--      <a-form-item-->
    <!--          label="线索池导入"-->
    <!--          :label-col="{ span: 4 }"-->
    <!--          :wrapper-col="{ span: 5 }">-->
    <!--        <uploader-->
    <!--            name="file"-->
    <!--            :multiple="false"-->
    <!--            :accept="'.xlsx'"-->
    <!--            :url="api.clue.DealerImportUPLOAD"-->
    <!--            :headers="{token:token}"-->
    <!--            :showUploadList="false"-->
    <!--            @change="importHandleChange"-->
    <!--        >-->
    <!--        </uploader>-->
    <!--      </a-form-item>-->
    <!--      <a-space class="a-form-btn-box">-->
    <!--        <a-button @click="closeImportPop()">取消</a-button>-->
    <!--        <a-button type="primary" @click="_save(false)">提交</a-button>-->
    <!--      </a-space>-->
    <!--    </formModal>-->

    <!-- 选择分配人 弹窗 -->
    <a-modal
        title="选择分配人"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="true"
        v-model="showAssignPop"
        :width="1200"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <sonDeptUsersList
          :assignIdArr="assignIdArr"
          v-if="showAssignPop"
          ref="sonDeptUsersList"
          @close="closePop"
      >
      </sonDeptUsersList>
    </a-modal>

    <!-- 经销商 弹窗 -->
    <a-modal
        title="选择经理部"
        centered
        :footer="null"
        :maskClosable="true"
        v-model="showTransferPop"
        :width="1200"
        :closable="true"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <sonDealerList
          :transferIdArr="transferIdArr"
          v-if="showTransferPop"
          ref="sonDealerList"
          @close="closeTransferPop"
      >
      </sonDealerList>
    </a-modal>

    <!--页面加载-->
    <loading></loading>
  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/clue/saleCluePool/saleCluePoolDetail";
import sonDeptUsersList from "./poolPop/deptUsersList";
import sonDealerList from "./poolPop/dealerList";

//弹出层组件
import {mapState} from "vuex";
import {dataApi} from "@/services/clue/clueManage";
import axios from "axios";
// import user from "@/services/user";
import loading from '@/components/common/loading'

const fac = XGrid.factory;

//列表接口
const url = api.clue.CLUEPOOL;

//主键
const rowId = "poolId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  // fac.makeColumnSeqDefault(),
  fac.makeColumn("poolId", "公海线索ID", 100, 'center'),
  fac.makeColumn("custName", "客户名称", 80, 'center'),
  fac.makeColumn("phone", "手机号", 120, 'center'),
  fac.makeColumn("companyName", "公司名称", 180, 'center'),
  fac.makeColumn("regionName", "经理部", 120, 'center'),
  fac.makeColumn("dealerName", "经销商", 120, 'center'),
  fac.makeColumn("provinceName", "意向省份", 120, 'center'),
  fac.makeColumn("cityName", "意向城市", 120, 'center'),
  // fac.makeColumn("strainName", "销售顾问", 100, 'center'),
  fac.makeColumn("sourceName", "第三方来源系统", 120, 'center'),
  fac.makeColumn("leadSourceName", "线索来源", 120, 'center'),
  fac.makeColumn("createDate", "线索创建时间", 200, 'center'),

  fac.makeColumn("strainName", "意向品系", 100, 'center'),
  fac.makeColumn("brandName", "意向品牌", 160, 'center'),
  fac.makeColumn("wantLevelName", "意向等级", 160, 'center'),
  fac.makeColumn("wantCount", "预购数量(台)", 160, 'center'),
  fac.makeColumn("dealChanceName", "成交概率", 160, 'center'),
  fac.makeColumn({
    title: "操作",
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 300,
    fixed: 'right'
  }),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "poolId", title: "公海线索ID"},
  {field: "custName"},//客户名称
  {field: "phone"},//手机号
  {field: "dealerName"},//经销商
  {field: "regionName"},//经理部
  {
    field: "isRegionEmpty",
    title: "经理部是否为空",
    type: "select",
    customSearch: true,
    options: [
      {label: "全部", value: ""},
      {label: "是", value: "1"},
      {label: "否", value: "0"}
    ]
  },//经理部是否为空
  {
    field: "sourceName",
    type: "select",
    options: []
  },//第三方线索来源
  {
    field: "leadSourceName",
    type: "select",
    options: []
  },//线索来源
  {
    field: "strainId",
    title: "意向品系",
    type: "select",
    options: [],
  },// 意向品系
  {
    field: "wantLevel",
    title: "意向等级",
    type: "select",
    options: [],
  },// 意向等级
  {field: "wantCount"},//预购数量
  {
    field: "dealChance",
    title: "成交概率",
    type: "select",
  },//成交概率
  {
    field: "createDate",
    type: "dateRange",
  },//线索创建时间
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  // this.strainOptions = await loadBaseCodeData('CD200007')
  this.strainOptions = await dataApi.getStrainList();
  this.dealChanceOptions = await loadBaseCodeData('CD200008')//成交概率
  this.sourceOptions = await loadBaseCodeData('CD200009')//第三方系统来源
  this.leadSourceOptions = await loadBaseCodeData('CD200004')//线索来源


  this.wantLevelOptions = await loadBaseCodeData('CD200002')
  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  // let commCodeData = await dataApi.getCommCode();
  // let DeptUsers = await dataApi.getDeptUsers();
  // if(DeptUsers.code!==200){
  //
  // }
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    isRegionId: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    isDealerId: this.dealerOptions,
  })


  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    wantLevel: this.wantLevelOptions,
  })

  //第三方线索来源
  this.sourceOptions = this.sourceOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.sourceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.sourceOptions);
  this.loadSearchOption({
    sourceName: this.sourceOptions,
  })
  //线索来源
  this.leadSourceOptions = this.leadSourceOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.leadSourceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.leadSourceOptions);
  this.loadSearchOption({
    leadSourceName: this.leadSourceOptions,
  })
  //成交概率
  this.dealChanceOptions = this.dealChanceOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.dealChanceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealChanceOptions);
  this.loadSearchOption({
    dealChance: this.dealChanceOptions,
  })
  this.strainOptions = this.strainOptions.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainId: this.strainOptions,
  })

}


export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   // delRow: 'DELETE',
  //   // importMethod:'IMPORT',
  //   // exportMethod:'EXPORT',
  // },
  components: {
    detailForm,
    sonDeptUsersList,
    sonDealerList,
    loading
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  watch: {
    $route: {
      handler() {
        this.startDate = this.$store.state.setting.startTime || null
        this.endDate = this.$store.state.setting.endTime || null
        if (this.$route.path === '/clue/saleCluePool') {
          this.changeNav(this.$store.state.setting.navSwitch)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      navSwitch: 0,
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      exportConfig:{
        remote: true,
        types: ['xlsx'],
        modes: ['all']
      },
      userIdList: [],
      strainOptions: [],
      wantLevelOptions: [],
      showImportPop: false,
      token: localStorage.getItem('token'),
      showAssignPop: false,
      assignIdArr: [],
      showTransferPop: false,
      transferIdArr: [],
      detailPage: false, // 线索池暂不做编辑功能
      startDate: this.$store.state.setting.startTime || null,
      endDate: this.$store.state.setting.endTime || null,
      role: '',//登录用户角色
      exportUrl: api.clue.CLUEPOOL + "/exportExcel?",
      exportParams: {}
    };
  },
  mounted() {
    let role = JSON.parse(localStorage.getItem('admin.user'))
    this.role = role.mainRoleName  //登录用户角色

    // this.exportParams = {
    //   'isDealerId': this.navSwitch,
    //   startDate: this.startDate,
    //   endDate: this.endDate
    // }
  },
  methods: {
    loadBaseData,
    changeNav(status) { //切换nav状态
      this.navSwitch = status;
      this.exportParams = {
        'isDealerId': this.navSwitch,
        startDate: this.startDate,
        endDate: this.endDate
      }
      console.log(1123)
      const vm = this;
      this.$nextTick(() => {
        vm.refresh()
      })
    },
    // 显示导入弹窗
    showImportPopFunc() {
      this.showImportPop = true;
    },
    // 关闭导入弹窗
    closeImportPop() {
      this.showImportPop = false;
    },
    // 下载模板
    download(type) {
      let fileUrl = '';
      if (type === 1) {
        fileUrl = 'cluePoolExample1.xlsx';
      } else {
        fileUrl = 'cluePoolExample2.xlsx';
      }
      axios.get(fileUrl, {   //静态资源文件夹public
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = '线索池导入模板.xls';
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    // 导入 厂家 区域 FactorImportUPLOAD
    // 导入 经销商 DealerImportUPLOAD
    async importHandleChange({file}) {
      this.bus.$emit('loading', true);
      if (file.status === 'done') {
        if (file.response.code == 500) {
          this.bus.$emit('loading', false);
          console.log('error', file)
          this.$message.error('导入数据不规范,示范文件下载中...')
          let downFile = api.clue.ERROREXCEL + 'error/' + file.response.msg + "?download=1";
          // let name1 = file.response.msg.split('.')[0];
          // let len = name1.split('/').length;
          // let name1Arr = name1.split('/');
          // let names = name1Arr[len-2];
          // let downloadElementEF = document.createElement("a");
          // console.log(downloadElementEF)
          // // let href = window.URL.createObjectURL(downFile); //创建下载的链接
          // downloadElementEF.href = downFile;
          // downloadElementEF.download = names + '导入校验失败数据.xlsx'; //下载后文件名
          // document.body.appendChild(downloadElementEF);
          // downloadElementEF.click(); //点击下载
          // document.body.removeChild(downloadElementEF); //下载完成移除元素
          axios.get(downFile, {responseType: "blob"})
              .then((res) => {
                const blob = new Blob([res.data], {
                  type: "application/vnd.ms-excel;charset=utf-8",
                });
                const href = window.URL.createObjectURL(blob);
                const downloadElement = document.createElement("a");
                downloadElement.href = href;
                var name = res.headers["content-disposition"];
                downloadElement.download = decodeURI(name.substring(name.lastIndexOf("=") + 1));
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
              }).catch((fail) => {
            console.error(fail);
          });
          // window.URL.revokeObjectURL(href); //释放掉blob对象
        } else {
          console.log('success', file)
          this.bus.$emit('loading', false);
          this.$message.success('导入成功')
        }
        this.showImportPop = false;
        this.refresh();
      }
    },
    // 弹出分配人列表 选择分配人进行分配
    showAssignPopFunc(row) {
      this.assignIdArr = [];
      //判断操作 是批量还是单条数据
      if (!row.poolId) { //批量
        let rowArr = this.getRows();
        if (!rowArr.length) {
          this.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          this.assignIdArr = rowResult.map(item => item.poolId);
          // console.log("this.assignIdArr",this.assignIdArr)
          this.showAssignPop = true;
        }
      } else {  //单条数据
        this.assignIdArr.push(row.poolId);
        // console.log("this.assignIdArr",this.assignIdArr)
        this.showAssignPop = true;
      }
    },
    // 关闭弹窗
    closePop() {
      this.showAssignPop = false; //分配人列表
      this.refresh();
    },
    // 领取线索
    receiveFunc(row) {
      let x = this.navSwitch
      if (x === 1)
        x = 0
      else if (x === 0)
        x = 1
      let that = this;
      let receiveIdArr = [];
      //判断操作 是批量还是单条数据
      if (!row.poolId) { // 批量
        let rowArr = that.getRows();
        if (!rowArr.length) {
          that.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = that.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          // let receiveGoodArr = rowResult.filter(item => item.isReceive === 0);
          // console.log('领取合格',receiveGoodArr)
          // receiveIdArr = receiveGoodArr.map(item => item.poolId);
          // console.log('领取id',receiveIdArr)
          receiveIdArr = rowResult.filter(item => item.isReceive === 0).map(item => item.poolId);
          console.log('领取id', receiveIdArr)
        }
      } else {  // 单条数据
        receiveIdArr.push(row.poolId);
      }
      let result = {
        idList: receiveIdArr.join(','),
        poolType: x    // 线索池类型 0是区域线索池 1是经销商线索池
      }
      // 调用接口领取
      this.loading(true);
      dataApi.getPoolReceive(result).then((res) => {
        this.loading(false);
        if (res.code === 200) {
          that.refresh();
          // let text=res.data
          that.$message.success('领取成功');
        } else {
          // let text=res.data
          that.$message.success('领取失败');
        }
      });
    },
    // 作废线索池
    async toVoidFunc(row) {
      let that = this;
      console.log('作废');
      let resultIdArr = [];
      //判断操作 是批量还是单条数据
      if (!row.poolId) { // 批量
        let rowArr = that.getRows();
        if (!rowArr.length) {
          that.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = that.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          resultIdArr = rowResult.map(item => item.poolId);
        }
      } else {  // 单条数据
        resultIdArr.push(row.poolId);
      }
      let result = {
        idList: resultIdArr.join(',')
      }
      this.$confirm({
        title: '确认作废？',
        async onOk() {
          // 调用接口 作废
          that.loading(true);
          let entity = await dataApi.getPoolToVoid(result);
          that.loading(false);
          if (entity.code === 200) {
            that.loading(false);
            that.refresh();
          }
        }
      })
    },
    // 弹出 经销商列表 选择经销商进行转移  - 转移 线索池（批量）
    showTransferPopFunc(row) {
      //判断操作 是批量还是单条数据
      if (!row.poolId) { //批量
        let rowArr = this.getRows();
        if (!rowArr.length) {
          this.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          this.transferIdArr = rowResult.map(item => item.poolId);
          this.showTransferPop = true;
        }
      } else {  //单条数据
        this.transferIdArr.push(row.poolId);
        this.showTransferPop = true;
      }
    },
    closeTransfer() {
      this.showTransferPop = false;
    },
    // 关闭转移弹窗
    closeTransferPop() {
      this.showTransferPop = false; //经销商树
      this.refresh();
    },
    backToSea(row) {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (row) {
        rows = [row]
      }
      if (rows.length < 1) {
        this.$message.error('请选择一条或多条数据')
        return false
      }
      const ids = rows.map(item => {
        return item.poolId
      }).toString()
      dataApi.rollbackClue(ids).then(res => {
        if (res.code === 200) {
          this.$message.success('退回成功')
          this.refresh();
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>

.status_box {
  margin: 0 30px 12px 0;
  position: relative;
  top: -6px;

  .status_item {
    width: 120px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 38px;
    display: inline-block;
    background-color: #E9F5FC;
    cursor: pointer;

    &.active {
      background-color: #D90B18;
      color: #fff;
    }
  }
}

.btns_box {
  //line-height: 60px;
  margin-right: 12px;
}

/deep/ .vxe-toolbar {
  .vxe-buttons--wrapper {
    margin-top: 20px;
  }
}

</style>
